import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:4000",
});

export const createOrder = async (payload) => {
  const { data } = await api.post("/api/orders", payload);
  return data;
};

export const createPaypalOrder = async (payload) => {
  const { data } = await api.post("/api/paypal/create-order", payload);
  return data;
};

export const capturePaypalOrder = async (payload) => {
  const { data } = await api.post("/api/paypal/capture-order", payload);
  return data;
};

/* ✅ FIX HERE */
const orderApi = {
  createOrder,
  createPaypalOrder,
  capturePaypalOrder,
};

export default orderApi;
